{
  "locationMasterTableConfig": {
    "columns": [

      {
        "fieldName": "name",
        "displayName": "Location Name",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "150px"
        }
      },
      {
        "fieldName": "panNumber",
        "displayName": "PAN Number",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "100px"
        }
      },
      {
        "fieldName": "locationType",
        "displayName": "Location Type",
        "dataType": "ARRAY",
        "thStyleConfig": {
          "width": "300px"
        },
        "styleConfig": {
          "type": "multi-tag"
        }
      },
      {
        "fieldName": "distanceFromCFS",
        "displayName": "Distance From CFS (in KM)",
        "dataType": "NUMBER",
        "thStyleConfig": {
          "width": "100px"
        }
      },
      {
        "fieldName": "active",
        "displayName": "Status",
        "dataType": "BOOLEAN",
        "valueMap": {
          "true": "Active",
          "false": "Inactive"
        },
        "styleConfig": {
          "type": "status"
        }
      },
      {
        "fieldName": "modifiedDate",
        "displayName": "Last Modified At",
        "dataType": "DATETIME",
        "sortable": true
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "createdBy",
        "displayName": "Created By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      }
    ]
  },
  "filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "IS_ACTIVE",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "IS_ACTIVE"
        }
      },
      {
        "name": "LOCATION_TYPE_IN",
        "displayLabel": "Location Type",
        "dataType": "DROPDOWN",
        "options":[],
        "operatorToFilterMap": {
          "EQ": "LOCATION_TYPE_IN"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search Location by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "location_name"
      }
    ]
  }
}
